"use client";

import { motion } from "framer-motion";
import Navbar from "@/app/components/Navbar";
import Footer from "@/app/components/Footer";

export default function TermsPage() {
  return (
    <>
      <Navbar />
      <main className="min-h-screen px-6 py-32" style={{ background: "#0A0908" }}>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-3xl mx-auto"
        >
          <h1
            className="text-3xl md:text-4xl font-light mb-2"
            style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}
          >
            Terms of Service
          </h1>
          <p
            className="text-xs mb-12"
            style={{ color: "rgba(245,240,232,0.3)", fontFamily: "'Montserrat', sans-serif" }}
          >
            Last updated: April 2024
          </p>

          <div className="space-y-8 text-sm leading-relaxed" style={{ color: "rgba(245,240,232,0.6)", fontFamily: "'Montserrat', sans-serif" }}>
            <section>
              <h2 className="text-lg font-light mb-3" style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}>
                Acceptance of Terms
              </h2>
              <p>
                By accessing and using Aurelius & Co, you accept and agree to be bound by the terms and provision of this agreement.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-light mb-3" style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}>
                Description of Service
              </h2>
              <p>
                Aurelius & Co provides Instagram automation services including automated DM responses, comment replies, and analytics for Instagram Business accounts. Our service uses Instagram's official Graph API.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-light mb-3" style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}>
                User Responsibilities
              </h2>
              <p className="mb-2">You agree to:</p>
              <ul className="space-y-2 pl-4">
                <li>• Use the service in compliance with Instagram's Terms of Use</li>
                <li>• Not send spam, abusive, or prohibited content</li>
                <li>• Not attempt to bypass rate limits or security measures</li>
                <li>• Maintain the security of your account credentials</li>
                <li>• Be at least 18 years old to use this service</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-light mb-3" style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}>
                Prohibited Uses
              </h2>
              <p className="mb-2">You may not use our service to:</p>
              <ul className="space-y-2 pl-4">
                <li>• Send unsolicited messages (spam)</li>
                <li>• Engage in deceptive or fraudulent activities</li>
                <li>• Violate Instagram's community guidelines</li>
                <li>• Harass, threaten, or defame others</li>
                <li>• Infringe on intellectual property rights</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-light mb-3" style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}>
                Account Termination
              </h2>
              <p>
                We reserve the right to terminate or suspend your account at any time for violation of these terms, abusive behavior, or if we believe your account poses a risk to our platform or users.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-light mb-3" style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}>
                Disclaimer of Warranties
              </h2>
              <p>
                THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND. WE DO NOT GUARANTEE THAT THE SERVICE WILL BE UNINTERRUPTED, SECURE, OR ERROR-FREE.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-light mb-3" style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}>
                Limitation of Liability
              </h2>
              <p>
                We shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the service.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-light mb-3" style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}>
                Contact Information
              </h2>
              <p>
                For questions about these Terms, contact us at support@aureliusco.com
              </p>
            </section>
          </div>
</motion.div>
      </main>
      <Footer />
    </>
  );
}